var exports = {
  "zr": "x93eb46d8--0ec3d3--root",
  "f": "x93eb46d8--0ec3d3--root_full",
  "O5": "x93eb46d8--0ec3d3--offers",
};

module.exports = exports;
